import React from "react";
import { ChevronLeft } from "lucide-react";

const ChatHeader = ({ userName, profilePicture, onBackPress }) => {
  return (
    <div className="flex flex-row items-center justify-between py-2 h-16 bg-black border-b border-gray-700">
      <button onClick={onBackPress} className="w-10 p-2">
        <ChevronLeft size={30} color="#fff" />
      </button>
      <div className="flex flex-row items-center flex-1 justify-center">
        <img
          src={profilePicture}
          alt="avatar"
          className="w-10 h-10 rounded-full mr-2 border border-gray-300 object-cover"
        />
        <span className="text-lg font-semibold text-white max-w-[60%] truncate">
          {userName}
        </span>
      </div>
      <div className="w-10 p-2" /> {/* Placeholder to balance layout */}
    </div>
  );
};

export default ChatHeader;
